import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../src/environments/environment';

@Component({
  selector: 'app-version',
  templateUrl: './app-version.component.html',
  styleUrls: ['./app-version.component.css']
})
export class AppVersionComponent implements OnInit {

  public version: string = environment.VERSION;

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/common/app-version/app-version.component.ts